import RestResource from '../rest.service';
import { MAPS_API_KEY } from '@/services/maps/API_KEY';

const defaultParams = {
  lat: null,
  lng: null,
  coordinates: [],
  size: '400x500',
  markerColor: 'red',
  pathColor: '0x1E90FF',
  zoom: 10,
  mapType: 'hybrid',
};

export default class MapsService extends RestResource {
  staticMap(params = defaultParams) {
    const p = { ...defaultParams, ...params };

    const color = `?markers=color:${p.markerColor}%7C`;
    const location = `${p.lat},${p.lng}&maptype=${p.mapType}`;
    const size = `&size=${p.size}&zoom=${p.zoom}&key=`;

    return `https://maps.googleapis.com/maps/api/staticmap${color}${location}${size}${MAPS_API_KEY}`;
  }

  staticMapWithPolygon(params = defaultParams) {
    const p = { ...defaultParams, ...params };
    let coordinates = '';

    p.coordinates.forEach((coordinate) => {
      coordinates = coordinates + '|' + coordinate.lat + ',' + coordinate.lng;
    });

    const path = `?path=color:${p.pathColor}00%7Cfillcolor:${p.pathColor}88`;
    const location = `${coordinates}&maptype=${p.mapType}`;
    const size = `&size=${p.size}&zoom=${p.zoom}&key=`;

    return `https://maps.googleapis.com/maps/api/staticmap${path}${location}${size}${MAPS_API_KEY}`;
  }

  staticPlace(lat, lng) {
    return `https://www.google.com/maps/place/${lat},${lng}`;
  }

  constructor() {
    super('maps');
  }
}
